<template>
	<div class="item_sidebar sticky_item_sidebar" :class="{'active': stickyData.enabled}">
		<div class="wrapper_title">
			<div class="title">Sticky</div>

			<label class="switch_checkbox_item">
				<input type="checkbox" @change="showMore" :checked="stickyData.enabled">
				<div class="switch_checkbox"><span></span></div>
			</label>
		</div>
		<div class="wrapper_body wrapper_body_block" v-if="stickyData.enabled">
			<div class="item border_select_style_wrpr">
				<div class="title flex">Position</div>
				<v-select class="positions-list small"
				          :options="types"
				          :searchable="false"
				          :clearable="false"
				          label="text"
				          v-model="value.position"
				          :reduce="item => item.id"
				          @input="updatedData(value.position, 'position')"
				          append-to-body
				          dense
				/>
			</div>

			<div class="item">
				<div class="title flex">Distance</div>
				<input-field min="0" max="10000" step="1" v-model.number="value.distance"
				             @change="updatedData($event, 'distance')" append="px" small type="number" />
			</div>
			<div class="item">
				<div class="title">Show after scrolling down</div>
				<input-field min="0" max="10000" step="10" v-model.number="value.after" placeholder="auto"
				             @change="updatedData($event, 'after')" append="px" small type="number" />
			</div>
		</div>
	</div>
</template>

<script>
import colorPicker from "@/modules/page-editor/src/components/sidebar/sidebar-items/colorPicker.vue"
import InputField from "@/components/base/input-field";

export default {
	name: 'Sticky',
	props: ['title', 'value'],
	components: {
		colorPicker,
		InputField
	},
	data: function () {
		return {
			stickyData: {
				enabled: false,
				position: 'top',
				distance: 0,
			},
			types: [
				{id:'top',text:'Top'},
				{id:'bottom',text:'Bottom'},
			],
		}
	},
	computed: {
		compData() {
			if (this.value !== '') {
				this.stickyData = {...this.value};
			}
			return this.stickyData;
		},
	},
	methods: {
		showMore(ev) {
			this.stickyData.enabled = ev.target.checked; //
			this.updatedData();
		},
		updatedData(val, fieldName, subFieldName) {
			if (fieldName === 'distance') {
				this.stickyData[fieldName] = +val;
			} else if (subFieldName) {
				this.stickyData[fieldName][subFieldName] = +val;
			} else {
				this.stickyData[fieldName] = val;
			}

			this.$emit('updated', this.stickyData);
		},
		sidesToggle(sideName) {
			this.updatedData()
		},
	},
	created() {
		if (this.value !== '') {
			this.stickyData = JSON.parse(JSON.stringify(this.value));
		}
	},
}
</script>
<style lang="scss" scoped>
.sticky_item_sidebar {
	&:not(.active) .wrapper_title {
		margin-bottom: 0 !important;
	}
	.positions-list {
		min-width: 100px;
	}
}
</style>
